interface ConsumerApiDto {
  url: string;
  dictKey: string;
  businessParam?: string;
  businessType?: number;
}

/**
 * 消费API接口地址列表
 */
export const consumerApiUrls: ConsumerApiDto[] = [
  /**
   * 查名下车
   */
  {
    url: '/v1/query/car/queryCarCount',
    dictKey: 'CLXX_A',
  },
  /**
   * 车辆估值
   */
  {
    url: '/v1/query/car/queryCarAssess',
    dictKey: 'CLXX_D',
  },
  /**
   * 行驶证查询
   */
  {
    url: '/v1/query/car/queryDrivingLicense',
    dictKey: 'CLXX_F',
  },
  /**
   * 车五项
   */
  {
    url: '/v1/query/car/queryCarVinFive',
    dictKey: 'CLXX_E',
  },
  /**
   * 人/企车主核验
   */
  {
    url: '/v1/query/car/queryCarContact',
    dictKey: 'CLXX_C',
  },
  /**
   * 车辆保险
   */
  {
    url: '/v1/query/car/queryCarAccident',
    dictKey: 'CLXX_H',
  },
  /**
   * 出险记录详情
   */
  {
    url: '/v1/query/car/queryCarAccidentInfo',
    dictKey: 'CLXX_G',
  },
  /**
   * 查询车辆过户次数信息
   */
  {
    url: '/v1/query/car/queryCarTransfer',
    dictKey: 'CLXX_B',
  },
  /**
   * 评估信息查询
   */
  {
    url: '/v1/query/assess/searchAssessCollect',
    dictKey: 'FCPG',
  },
  /**
   * 校验三要素
   */
  {
    url: '/v1/query/tools/verifyThree',
    dictKey: 'CVTA',
  },
  /**
   * 校验四要素
   */
  {
    url: '/v1/query/tools/verifyFour',
    dictKey: 'CVFA',
  },
  /**
   * 查房产
   */
  {
    url: '/v1/query/tools/realEstate',
    dictKey: 'CBDC',
  },
];

/**
 * 上传接口项目名称
 */
export const uploadProjectName = import.meta.env.VITE_UPLOAD_PROJECT_NAME;
